module.exports = __webpack_public_path__ + "static/media/hexagon_base_blue_orange_white.79fdc28b.svg";